<template>
  <div class="p-x-20 p-y-14 bg-white">
    <label
      class="f-Overpass f-14 f-c-black remove-margin"
      style="font-weight: bolder"
      >Kamu Punya Voucher atau Kode Promo?</label
    >
    <div class="promo">
      <input
        type="text"
        class="form-control inputs"
        id="input-text"
        placeholder="Masukan disini"
        v-model="dataInput"
      />
      <button
        id="btn_promo"
        type="button"
        class="btn form-control"
        @click="handleButtonClick"
      >
        Gunakan PROMO
      </button>
    </div>
  </div>
</template>

<script>
import SOModalAnnouncement from "@/so-components/global/modal/SOModalAnnouncement.vue";
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "FormInputJadwal",
  components: {
    SOModalAnnouncement,
  },
  data() {
    return {
      dataInput: "",
    };
  },
  computed: {
    ...mapGetters(moduleName, {
      formJadwal: "formJadwal",
    }),
  },
  methods: {
    ...mapActions({
      postCekPromo: `${moduleName}/postCekPromo`,
    }),

    async handleButtonClick() {
      let res = await this.postCekPromo(this.dataInput);
      if (res != "kode promo tidak valid") {
        this.formJadwal.pembayaran.kode_promo = this.dataInput;
      } else {
        this.$toast.error("kode promo tidak ditemukan");
      }
    },
  },
};
</script>
